/** @file Writes a track's mixed result into the running base sample (keyed channels only). */
import type { Sample } from '../contracts/sample';

/** Copies deform buffer i of r into base when r keys it, and marks it keyed. */
function commitDeform(base: Sample, r: Sample, i: number): void {
  const src = r.deform[i];
  const dst = base.deform[i];
  if (r.deformKeyed[i] !== 1 || src === undefined || dst === undefined) return;
  dst.set(src);
  base.deformKeyed[i] = 1;
}

/** base := r wherever r keys a channel (values and mask bits by mask, inherit >= 0, attachments != -2, draw order, deform). */
export function commitTrack(base: Sample, r: Sample): void {
  for (let c = 0; c < r.mask.length; c++) {
    if ((r.mask[c] ?? 0) === 0) continue;
    base.values[c] = r.values[c] ?? 0;
    base.mask[c] = 1;
  }
  for (let b = 0; b < r.inherit.length; b++) {
    const mode = r.inherit[b] ?? -1;
    if (mode >= 0) base.inherit[b] = mode;
  }
  for (let s = 0; s < r.attachments.length; s++) {
    const placeholder = r.attachments[s] ?? -2;
    if (placeholder !== -2) base.attachments[s] = placeholder;
  }
  if (r.drawOrderKeyed) {
    base.drawOrderKeyed = true;
    base.drawOrder.set(r.drawOrder);
  }
  for (let i = 0; i < r.deform.length; i++) commitDeform(base, r, i);
}
